// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Profile,
    ProfileFromJSON,
    ProfileToJSON,
} from './';

/**
 * 
 * @export
 * @interface PeopleSearchResults
 */
export interface PeopleSearchResults {
    /**
     * 
     * @type {number}
     * @memberof PeopleSearchResults
     */
    count: number;
    /**
     * 
     * @type {Array<Profile>}
     * @memberof PeopleSearchResults
     */
    results: Array<Profile>;
    /**
     * 
     * @type {any}
     * @memberof PeopleSearchResults
     */
    aggregations: any;
}

export function PeopleSearchResultsFromJSON(json: any): PeopleSearchResults {
    return {
        'count': json['count'],
        'results': (json['results'] as Array<any>).map(ProfileFromJSON),
        'aggregations': (json['aggregations']),
    };
}

export function PeopleSearchResultsToJSON(value?: PeopleSearchResults): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'count': value.count,
        'results': (value.results as Array<any>).map(ProfileToJSON),
        'aggregations': (value.aggregations),
    };
}


